import { Check } from 'lucide-react';

const WHY_CHOOSE_ITEMS = [
  'U.S. Company Presence',
  'Factory-Direct Manufacturing',
  'Custom OEM Production',
  'Low MOQ Available',
  'Door-Delivered USA Service',
  'Quality-Focused Manufacturing',
  'Cotton Canvas, Jute & Promotional Bags',
];

export const WhyChooseUsSection = () => {
  return (
    <section className="py-[60px] md:py-20 bg-[#FAFAFA] border-t border-gray-200" data-testid="why-choose-us-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-2xl sm:text-3xl text-[#2B2B2B] mb-10 md:mb-12 text-center font-semibold">
          Why Choose US?
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-[30px] max-w-5xl mx-auto">
          {WHY_CHOOSE_ITEMS.map((item) => (
            <div
              key={item}
              className="bg-white rounded-lg border border-[#E8E8E8] p-5 md:p-6 shadow-sm flex items-start gap-3"
            >
              <div className="w-5 h-5 rounded-full bg-[#2F4F3E] flex items-center justify-center flex-shrink-0 mt-0.5">
                <Check className="w-3 h-3 text-white" />
              </div>
              <p className="text-sm md:text-base font-semibold text-[#2B2B2B] leading-snug">
                {item}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
